import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { projectType, menuItemType } from 'types';

import styles from '../MenuItem/style.scss';

const LinkedMenuItem = ({ item, currentProject, children }) => {
  const { account, slug } = currentProject;

  return (
    <NavLink
      activeClassName={styles.active}
      to={`/${account}/${slug}/${item.uiSref}`}
    >
      {children}
    </NavLink>
  );
};

LinkedMenuItem.propTypes = {
  currentProject: projectType,
  item: menuItemType,
  children: PropTypes.node,
};

export default LinkedMenuItem;
